import request from '@/utils/request'
// import store from '../store'

export function fleZipUploadFile(datas, onUploadProgress) {
  return request({
    url: 'Examin/UploadDicomPack?departId=' + datas.data.departId + '&hospId=' + datas.data.hospId,
    method: 'post',
    data: datas.formData, // 直接使用 FormData 对象
    headers: { 'Content-Type': 'multipart/form-data;' },
    timeout: 0,
    onUploadProgress
  })
}

export function GetUploadImagesRecordsByHospId(datas) {
  return request({
    url: 'Examin/GetUploadImagesRecordsByHospId',
    method: 'post',
    data: datas
  })
}

export function GetHospInfo(datas) {
  return request({
    url: 'Examin/GetHospInfo',
    method: 'get',
    data: datas
  })
}
